<template>
  <span> {{ formattedDistance }} {{ unit }} </span>
</template>

<script>
  import { defineComponent, computed } from '@vue/composition-api'

  export default defineComponent({
    props: {
      distance: {
        required: true,
        type: Number,
      },
    },
    setup(props) {
      const isSmallDistance = props.distance < 100

      const formattedDistance = computed(() => {
        if (isSmallDistance) return props.distance.toFixed(0)
        return (props.distance / 1000).toFixed(1)
      })

      const unit = computed(() => {
        if (isSmallDistance) return 'm'
        return 'km'
      })
      return { unit, formattedDistance }
    },
  })
</script>
